import { defineStore } from 'pinia'

export const useActivityPropertyStore = defineStore('activityProperty', {
	state: () => ({
		property: {} as any,
		rooms: [] as any[],
		selectedRate: {} as any,
		selectedRoom: {} as any,
		reviewsInfo: {} as any,
		isBookDirectBtn: false,
		soldOutRates: [] as string[],
		currentSoldOutRate: null as string | null,
    packages: <Array<any>>[],
    // A package lookup for the currently selected date is in flight.
    packagesLoading: false,
    // A package lookup for the currently selected date has COMPLETED. Without this the page
    // cannot tell "no date chosen yet" from "this date came back with nothing", so a sold-out
    // date rendered the same "Choose a date to get started" prompt the user had just answered.
    packagesChecked: false,
    selectedPackageId: <string>'',
    criteria: { adults: 2, children: 0 } as any,
	}),
	getters: {
		getTotalVisitors(state) {
			return state.criteria.adults + state.criteria.children
		},
	},
	actions: {
    setPackages(value:Array<any>) {
      this.packages = value
    },
    setPackagesLoading(value: boolean) {
      this.packagesLoading = value
    },
    setPackagesChecked(value: boolean) {
      this.packagesChecked = value
    },
		addSoldOutRate(rateRef: string) {
			this.soldOutRates.push(rateRef)
		},
		setCurrentSoldOutRate(rateRef: string) {
			this.currentSoldOutRate = rateRef
		},
		setBookDirectBtnVisible(value: boolean) {
			this.isBookDirectBtn = value
		},
		setProperty(value: any) {
			this.property = value
		},
		setRooms(value: any) {
			this.rooms = value
		},
		setSelectedRate(value: any) {
			this.selectedRate = value
			this.findRoomBySelectedRate()

		},
		setReviewsInfo(value: any) {
			this.reviewsInfo = value
		},
		clearSelectedRate() {
			this.selectedRate = {}
		},
		findRoomBySelectedRate() {
			this.selectedRoom  = this.rooms.find(room => room.rates.find((rate: any) => rate.ref === this.selectedRate.ref))
		},
		clearRooms() {
			this.rooms = []
		},
    setSelectedPackageId(packageId: string) {
      this.selectedPackageId = packageId
    }
	},
})
